export default {
	Slide: 'Puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'Układanka jest otwarta!',
	'Congratulations!': 'Gratulacje!',
	'You get it': 'Dostajesz',
	'You get the task done': 'Wykonasz zadanie',

	'Show all blocked': 'Pokaż wszystkie zablokowane',

	Author: 'Autor',
	'Reset filters': 'Zresetuj filtry',

	Blocked: 'Zablokowany',
	Unlocked: 'Odblokowany',

	Change: 'Zmiana',
	'The student is blocked': 'Uczeń jest zablokowany',
	'The student is blocked with a new price':
		'Student zostaje zablokowany nową ceną',
	'To unlock this student, go to the "Restore" section':
		'Aby odblokować tego ucznia, przejdź do sekcji „Odzyskiwanie”',

	'Before blocking, you can change the price for the student':
		'Przed zablokowaniem możesz zmienić cenę dla studenta',

	'Block student': 'Blokuj ucznia',

	'First month cost': 'Cena za 1 miesiąc',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'Uwaga! Po ponownym zapisaniu dodanej już pracy domowej, uczniowe którzy już je ukończyli utracą swój postęp i będą musieli zrobić je ponownie.',

	"You cannot do homework in the student's platform":
		'Nie możesz odrabiać lekcji na platformie ucznia',

	'Restore the student ?': 'Przywrócić ucznia?',
	'Restore the teacher ?': 'Przywrócić nauczyciela?',
	'Restore the franchise ?': 'Przywrócić franczyzę?',

	'Transition to 50': 'przejście do 50',
	'Transition to 100': 'przejście do 100',

	fifty: 'przejście do 50',
	hundred: 'przejście do 100',

	Faces: 'Twarze',

	Heroes: 'Bohaterowie',
	Clothes: 'Odzież',
	Backgrounds: 'Tła',
	Souvenirs: 'Pamiątki',

	'Coming soon': 'Wkrótce',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Wow! Gratulacje, pomyślnie kupiłeś ten produkt.',
	'You can view all your purchases in the "Purchased" section':
		'Możesz zobaczyć wszystkie swoje zakupy w sekcji „Kupione”',

	'Your savings': 'Twoje oszczędności',
	'You can spend them on something interesting!':
		'Możesz je wydać na coś ciekawego!',

	'A student with this email address already exists':
		'Użytkownik z takim adresem e-mail już istnieje',

	'User with such email already exists':
		'Użytkownik z takim adresem e-mail już istnieje',
	'Year of birth': 'Rok urodzenia',
	Registration: 'Rejestracja',
	'Surname of parents': 'Nazwisko rodziców',
	School: 'Szkoła',
	'Field is required': 'To pole jest wymagane',
	'Select age': 'Wybierz wiek',
	'No such teacher for this year': 'Brak takiego nauczyciela w tym roku',
	'User with such phone number already exists':
		'Użytkownik o takim numerze telefonu już istnieje',
	'You are successfully registered': 'Zostałeś pomyślnie zarejestrowany',
	'Max length 20 chars': 'Maksymalna długość 20 znaków',

	'INTERNATIONAL SCHOOL': 'SZKOŁA MIĘDZYNARODOWA',
	'Mental Arithmetic': 'Arytmetyka mentalna',
	'For children aged 5-14.': 'Dla dzieci w wieku 5-14 lat.',
	'Sign up for a trial lesson': 'Zapisz się na lekcję próbną',
	'Parents name': 'Imię rodziców',
	'Childs age': 'Wiek dziecka',
	Country: 'Kraj',
	'Sign up': 'Zapisz się',
	'Open offer agreement': 'Umowa z otwartą ofertą',

	'Participate in online Indigo Olympiad':
		'Rywalizuj z innymi w naszej olimpiadzie INDIGO online! ',
	Participate: 'Weź udział',
	export: 'Eksport',
	wrong: 'Niepoprawnie',
	right: 'Poprawnie',
	match: {
		addition: 'Dodawanie i odejmowanie',
		multiply: 'Mnożenie',
		divide: 'Dzielenie',
		abacus_random: 'Abacus random',
		anzan: 'Anzan',
		negative: 'Liczby ujemne',
		column: 'Kolumny',
	},
	timeIsOver: 'Czas się skończył',
	timer: 'Regulator czasowy',
	'Back to Lessons': 'Wróć do listy lekcji',
	'Create Lesson': 'Rozpocznij lekcję',
	Assign: 'Wyznacz termin',
	Home: 'Do strony głównej',
	'To cabinet': 'Do gabinetu',
	'Create a homework': 'Utwórz pracę domową',
	January: 'Styczeń',
	February: 'Luty',
	March: 'Marzec',
	April: 'Kwiecień',
	May: 'Maj',
	June: 'Czerwiec',
	July: 'Lipiec',
	August: 'Sierpień',
	'Group nickname': 'NICK grupy',
	September: 'Wrzesień',
	October: 'Październik',
	November: 'Listopad',
	December: 'Grudzień',
	Overall: 'W całości',
	Active: 'Aktywni',
	'Contract number': 'Numer umowy',
	'For parents': 'Dla rodziców',
	'Choose lessons': 'Wybierz lekcje',
	Save: 'Przydziel',
	Close: 'Zamknij',
	'Change birthday': 'Zmień datę urodzenia',
	Sent: 'Wysłano',
	'Choose date': 'Wybierz datę',
	'Include students': 'Dołącz uczniów',
	'Add service': 'Dodaj usługę',
	'Create folder': 'Utwórz folder',
	Answer: 'Odpowiedź',
	Price: 'Cena',
	'Date of creating': 'Data utworzenia',
	Month: 'Miesiąc',
	unpaid: 'Nie opłacony',
	paid: 'Opłacony',
	'Excluded students': 'Wykluczeni uczniowie',
	'Selected groups': 'Wybrane grupy',
	Monday: 'Poniedziałek',
	Tuesday: 'Wtorek',
	Wensday: 'Środa',
	Thusday: 'Czwartek',
	Friday: 'Piątek',
	Saturday: 'Sobota',
	Sunday: 'Niedziela',
	Mo: 'Pn.',
	Tu: 'Wt.',
	We: 'Śr.',
	Th: 'Czw.',
	Fr: 'Pt.',
	Sa: 'Sob.',
	Su: 'Niedz.',
	End: 'Koniec',
	'Add discount': 'Dodaj zniżkę',
	Edit: 'Redaguj',
	'Parent found': 'Rodzic znaleziony',
	'Changes saved': 'Zmiany zapisane',
	'The passwords of the parent and the student should not coincide':
		'Hasła rodzica i ucznia nie powinny być takie same',
	'Your region`s price is set to': 'Cena dla twojego regionu wynosi',
	'and the holder`s reward is': 'nagroda dla posiadacza',
	'regardless of the set price': 'niezależnie od ustalonej ceny',
	'The given password is not unique for this email':
		'Podane hasło nie jest unikatowe dla tego adresu e-mail',
	'Enter a valid email address.': 'Wprowadź poprawny adres e-mail',
	'The phone number entered is not valid':
		'Wprowadzony numer telefonu jest nieprawidłowy',
	Holiday: 'Dni wolne',
	'Working days': 'Dni robocze',
	Street: 'Ulica',
	'Location name': 'Nazwa lokalizacji',
	District: 'Dzielnica',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Arytmetyka mentalna to metoda obliczeń ustnych, która szybko rozwija zdolności umysłowe i inteligencję dziecka w wieku od 5 do 14 lat. Proces uczenia odbywa się na specjalnych liczydłach japońskich Abakus. Arytmetyka mentalna uaktywnia jednocześnie lewą i prawą półkulę mózgu, poprawiając pamięć wzrokową, koncentrację, wyobraźnię i twórcze myślenie u dzieci i ich zdolność opanowania technik szybkiego czytania.',
	'Field required': 'Pole obowiązkowe',
	'Type of legal activity': 'Rodzaj osoby prawnej',
	'Legal address': 'Adres urzędowy',
	'Registration number': 'Numer rejestracyjny',
	'Add Group': 'Dodaj grupę',
	'Add Student': 'Dodaj ucznia',
	Signin: 'Logowanie',
	'Bonus days': 'Dni bonusowe',
	'Bonus weeks': 'Tygodnie bonusowe',
	'Are you sure you want to delete?': 'Jesteś pewien że chcesz usunąć?',
	Delete: 'Usuń',
	Days: 'Dni',
	Confirm: 'Potwierdź',
	Cancel: 'Anuluj',
	Week: 'Tydzień',
	Weeks: 'Tygodnie',
	'Group age name': 'Nazwa grupy w zależności od wieku',
	'Set bonus days': 'Ustaw dni bonusowe',
	'Default language': 'Język domyślny',
	'With english': 'Z angielskim',
	'Without english': 'Bez angielskiego',
	'Paid status': 'Status opłaty',
	'Not paid': 'Nie opłacony',
	Turnover: 'Obrót',
	Block: 'Zablokuj',
	Blocked: 'Zablokowani',
	'On holidays': 'Na wakacjach',
	Language: 'Język',
	Discounts: 'Zniżki',
	Message: 'Wiadomości',
	Subject: 'Temat',
	Homework: '[PD] Praca Domowa',
	'Homework ': 'Trening',
	'Homework on': 'Praca domowa na',
	'You need to complete the exercises': 'Musisz ukończyć ćwiczenia',
	Homework: 'Prace domowe',
	'Invoice for': 'Faktura',
	"PJSC CB 'PRIVATBANK' in Kyiv": "ПАТ КБ 'ПРИВАТБАНК' м. Киев",
	Account: 'Konto',
	Supplier: 'Dostawca',
	Buyer: 'Kupujący',
	'Bank code': 'Kod bankowy',
	'Type phone number or email':
		'Wprowadź swój numer telefonu albo adres e-mail',
	'Type password': 'Wprowadź hasło',
	'Forgot password': 'Zapomniałem hasła',
	'Type your email': 'Wprowadź swój adres e-mail',
	Send: 'Wyślij',
	'Email sent': 'E-mail wysłany',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Jeżeli twoje konto przypisane do danego adresu e-mail istnieje, wyślemy e-maila w celu uzyskania dostępu do twojego konta.',
	'Back to the sign in': 'Powrót do strony logowania',
	'Password or login is not correct': 'Niepoprawne hasło lub login',
	'Password recovery': 'Odzyskiwanie hasła',
	'Type your new password here': 'Wprowadź swoje nowe hasło',
	'Set new password': 'Utwórz nowe hasło',
	'Learn more': 'Dowiedz się więcej',
	'About Us': 'O nas',
	Company: 'Firma',
	Jobs: 'Praca',
	Press: 'Prasa',
	'Terms of Use': 'Warunki korzystania',
	'Privacy Policy': 'Polityka prywatności',
	'Need help?': 'Potrzebujesz pomocy?',
	'Contact us': 'Skontaktuj się z nami',
	'Become franchise': 'Franczyza',
	'Select language': 'Wybierz język',
	English: 'Angielski',
	Russian: 'Rosyjski',
	New: 'Nowy',
	Azerbaijani: 'Azerbejdżanu',
	Ukrainian: 'Ukraiński',
	Polish: 'Polski',
	Management: 'Zarząd',
	'Master Franchise': 'Master - franczyzobiorca ',
	Franchise: 'Franczyzobiorcę',
	Teachers: 'Nasza kadra dydaktyczna ',
	Groups: 'Grupy',
	Students: 'Uczniowie',
	Student: 'Uczeń',
	Parents: 'Rodzice',
	Profile: 'Profil',
	'My profile': 'Mój profil',
	Finance: 'Finanse',
	Reports: 'Sprawozdania',
	Report: 'Sprawozdanie',
	Upload: 'Załaduj',
	List: 'Lista',
	Payments: 'Płatności',
	Documents: 'Dokumenty',
	Lessons: 'Lekcje',
	Materials: 'Materiały',
	Shop: 'Sklep',
	Statistics: 'Statystyka',
	Settings: 'Ustawienia',
	Pages: 'Strony',
	Logout: 'Wyjście',
	Dashboard: 'Twoje konto',
	'Access denied': 'Dostęp zabroniony',
	Create: 'Utwórz',
	Download: 'Prześlij',
	Status: 'Status',
	'Payment Date': 'Data płatności',
	'Payment Amount': 'Suma płatności',
	'Start time': 'Godzina rozpoczęcia zajęć',
	'Group age': 'Wiek grupy',
	Junior: 'Juniorzy',
	Average: 'Średniozaawansowani',
	Class: 'Klasa',
	Older: 'Zaawansowani',
	Region: 'Region',
	Group: 'Grupa',
	Person: 'Osoba',
	Finances: 'Finanse',
	Actions: 'Działania',
	'Send invoice': 'Wyślij fakturę',
	'Download invoice': 'Pobierz fakturę',
	'Send email': 'Wyślij e-mail',
	'Create Student': 'Utwórz ucznia',
	'The beginning of holidays': 'Początek świąt',
	'Start of study': 'Początek nauki',
	'Group name': 'Nazwa grupy',
	'Group address': 'Adres',
	'Group teacher': 'nauczyciel grupy',
	'Group students': 'Uczniowie grupy',
	'Group statistics': 'Statystyka',
	Search: 'Szukaj',
	'General information': 'Ogólna informacja',
	'Phone number': 'Numer telefonu',
	'First name': 'Imię',
	Surname: 'Nazwisko',
	'Last name': 'Nazwisko',
	'Date of birth': 'Data urodzenia',
	Password: 'Hasło',
	'Additional information': 'Informacje dodatkowe',
	'Id code': 'Kod ID',
	Passport: 'Dowód osobisty',
	'Without email newsletter': 'Bez newslettera',
	'With email newsletter': 'Z newsletterem',
	'Financial information': 'Informacje o finansach',
	Royalty: 'Royalties',
	'PR contribution': 'PR składka',
	Currency: 'Waluta',
	Comment: 'Komentarz',
	Paid: 'Opłacony',
	Invoices: 'Rachunek',
	Bills: 'Rachunek',
	Acts: 'Ustawy',
	Scan: 'Skany',
	Level: 'Poziom',
	'Action with numbers': 'Działania z liczbami',
	'Action with number': 'Ilość działań',
	'Number of expressions': 'Ilość przykładów',
	'Number of expression': 'Ilość przykładów',
	'Imaginary abacus': 'Liczenie w wyobraźni',
	'Period report': 'Raport okresowy',
	City: 'Miasto',
	'Full name franchise': 'Imię i nazwisko franczyzobiorcy',
	'Students active': 'Uczniowie: aktywni',
	'Сost of education': 'Cena abonamentu',
	'Turnover franchise': 'Obrót',
	'Discount sum': 'Suma zniżek',
	Proprietor: 'Właściciel',
	'Additional products and services': 'Dodatkowe produkty i usługi',
	'Full name student': 'Imię i nazwisko ucznia',
	'Period of study': 'Okres nauczania',
	'Bonus-days': 'Dni bonusowe',
	'Amount of days': 'Ilość dni',
	'Total days': 'Całkowita ilość dni',
	'Language of instruction': 'Język nauczania',
	Teacher: 'Nauczyciela',
	Discount: 'Zniżka',
	Remuneration: 'Wynagrodzenie',
	Goods: 'Towary',
	'Date of creation': 'Data utworzenia',
	'Date of payment': 'Data opłaty',
	'Goods (works, services)': 'Towary (prace, usługi)',
	Quantity: 'Ilość',
	Units: 'Jednostki',
	Amount: 'Ilość',
	Sum: 'Suma',
	'Sum Sub': 'Dodawanie i odejmowanie',
	Financial: 'Finansowa',
	Additional: 'Dodatkowa',
	General: 'Ogólna',
	Total: 'Całkowicie',
	Save: 'Zachowaj',
	'Including with': 'Łącznie z',
	'Training materials': 'Materiały szkoleniowe',
	'Learning contract': 'Warunki nauki',
	Games: 'Gry',
	'NUMBER OF 11 TO 120': 'LICZBY OD 11 DO 120',
	Complexity: 'Złożoność',
	Start: 'Start',
	'Speedy numbers': 'Dodawanie i odejmowanie',
	Anzan: 'Anzan',
	'Abacus is random': 'Abakus losowy',
	Multiplication: 'Mnożenie',
	Division: 'Dzielenie',
	Abacus: 'Abakus',
	'Multiplying by 20': 'Mnożenie do 20',
	Squared: 'Potęgowanie',
	'Division to 20': 'Dzielenie do 20',
	Speed: 'Prędkość',
	Repeat: 'Powtórki',
	'Game type': 'Typ gry',
	'Digit type': 'Typ liczb',
	Digit: 'Liczba',
	Time: 'Czas',
	Oral: 'Liczydła w wyobraźni',
	Second: 'Sekundy',
	'Calculation method': 'Sposób liczenia',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Tylko ujemne liczby, zaczynając od 99,999,9999 itd., w zależności od złożoności przykładu: -9, -2, -3, -1 …',
	'Only subtraction': 'Tylko odejmowanie',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Tylko dodawanie, zaczynając od zera. Przykład : +1, +4, +6, +9, +5 …',
	'Only add': 'Tylko dodawanie',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Liczby wypadają losowo, zaczynając od 0. Przykład: +3, -5, -1, +9, -2 …',
	'Random numbers': 'Liczby losowe',
	'CHOOSE COMPLEXITY:': 'WYBIERZ STOPIEŃ TRUDNOŚCI',
	'AMOUNT OF ACTIONS WITH NUMBER': 'ILOŚĆ DZIAŁAŃ Z LICZBAMI',
	FAMILY: 'RODZINA',
	'BIG FRIENDS': 'WIELCY PRZYJACIELE',
	'LITTLE FRIENDS': 'MALI PRZYJACIELE',
	'JUST FRIENDS': 'PO PROSTU PRZYJACIELE',
	family: 'rodzina',
	'big friends': 'wielcy przyjaciele',
	'small friends': 'mali przyjaciele',
	elementary: 'po prostu przyjaciele',
	Sound: 'dźwięk',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Gratulacje! Udało ci się! Teraz możesz przejść do kolejnych ćwiczeń.',
	'RIGHT. ANSWER:': 'PRAWIDŁOWO. ODPOWIEDŹ.',
	'NOT CORRECT': 'NIEPRAWIDŁOWO',
	'Try again': 'Spróbuj jeszcze raz',
	expression: 'przykład',
	next: 'następny',
	Next: 'Następny',
	Previous: 'Poprzedni',
	Loading: 'Wczytywanie',
	back: 'wstecz',
	Back: 'WSTECZ',
	ANSWER: 'ODPOWIEDŹ',
	Lesson: 'Lekcja',
	'History statistics': 'Historia statystyki',
	Open: 'Otworzyć',
	'Game statistics per day': 'Dzienna statystyka gry',
	'Total played games': 'Ilość rozegranych gier',
	'Total correct answers': 'Ilość prawidłowych odpowiedzi',
	'Total played:': 'Całkowita ilość zagranych',
	Feedback: 'Kontakt zwrotny',
	'Leave a review': 'Zostaw komentarz',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Przekaż nam swoją opinię oraz sugestie,,ia, a my weźmiemy je pod uwagę w naszej dalszej pracy.',
	'Payment history': 'Historia płatności',
	'Payment status': 'Status opłaty',
	Pay: 'Zapłać',
	Payer: 'Płatnik',
	'Getting a discount': 'Otrzymać zniżkę',
	Training: 'Trening',
	Tasks: 'Zadania',
	'Current task': 'Bieżące zadanie',
	'Only task': 'Kategoria',
	'Next tasks': 'Następne zadania',
	'Online abacus': 'Abakus online',
	'Base 50/100': 'Podstawa 50/100',
	multiply_base: 'Podstawa 50/100',
	Add: 'Dodaj plik',
	'Add file': 'Додати файл',
	divided: 'podzielony',
	divider: 'dzielnik',
	'Do not show this instruction again': 'Nie pokazuj ponownie tej instrukcji',
	'Instructions for homework': 'Instrukcje dotyczące pracy domowej',
	'Multiplication table': 'Tabliczka mnożenia',
	Restore: 'Przywróć',
	Left: 'Lewo',
	'Restore Hierarchy': 'Przywróć hierarchię',
	total: 'ogółem',
	active: 'aktywne',
	blocked: 'zablokowany',
	pageError: {
		'403': 'Odmowa dostępu',
		'404': 'Ta strona nie istnieje. Spróbuj ponownie.',
		'500': 'Serwer nie odpowiada. Spróbuj ponownie.',
	},
	error: {
		'Account deactivated': 'Twoje konto zostało dezaktywowane.',
	},
	modalNewVersion: {
		text:
			'Używasz przestarzałej wersji witryny.\nAktualizacja jest już dostępna.',
		btn: 'Odśwież',
	},
	games: {
		negativeNumbers: 'Liczby ujemne',
		pause: 'Pauza',
		resume: 'Kontynuuj',
		columns: {
			name: 'Kolumny',
			users: 'Liczba graczy',
			user: 'Gracz',
			userNames: 'Nazwy graczy',
		},
	},

	'Indigo-dollars': 'Dolary indigo',
	Balance: 'saldo',

	modalIndigoDollars: {
		submit: 'Prześlij',
		cancel: 'Anuluj',
		title: 'Dolary indigo',
		balance: 'Aktualne saldo',
		amount: 'Ilość',
		reason: 'Komentarz',
	},

	modalAddNotification: {
		title: 'Dodaj powiadomienie',
		submit: 'Prześlij',
		cancel: 'Anuluj',
		empty: 'Brak powiadomień',
	},
	modalTransactionsHistory: {
		title: 'Historia płatności',
		type: {
			withdraw: 'Odpis',
			deposit: 'Uzupełnienie',
		},
		empty: 'Lista płatności jest pusta.',
	},

	modalCopyHomework: {
		title: 'Skopiuj pracę domową',
		label: 'Wybierz dzień, na który chcesz skopiować pracę domową',
		submit: 'Kopiuj',
		cancel: 'Anuluj',
	},

	reportsPage: {
		history: {
			title: 'Zmień historię',
			empty: 'Siyahı boşdur.',
			table: {
				date: 'Zmień datę',
				field_name: 'Działanie',
				old_value: 'Stare znaczenie',
				new_value: 'Nowa wartość',
				user: 'Zmodyfikowany przez użytkownika',
			},
		},
	},

	pageShop: {
		title: 'Sklep',
		description:
			'W sklepie można kupić wiele różnych motywów, które poprawią wygląd Twojego osobistego konta.',

		tabs: {
			all: 'Wszystkie motywy',
			purchased: 'Kupione',
		},

		item: {
			off_all: 'Nie',

			status: {
				AVAILABLE: 'Polecane',
				DEPRECATED: 'Niedostępny',
				COMING_SOON: 'Wkrótce',
			},
			is_activated: 'Wybrany',
			set_active: 'Wybierz',
			unset_active: 'Wyłącz',
			preview: 'Popatrz',
			is_free: 'Bezpłatny',
			buy: 'Kup',
			bought: 'Do kupienia',
			purchased: 'Do kupienia',
		},
		empty: {
			all: 'Brak dostępnych ulepszeń',
			purchased: 'Nie zakupiono żadnych aktualizacji',
		},

		toast: {
			error: 'Wystąpił błąd',
			notEnoughMoney: 'Niewystarczające środki',
			itemBought: 'Zakupione ulepszenie',
			itemActivated: 'Aktywowano ulepszenie',
			itemDeactivated: 'Ulepszona dezaktywacja',
		},
		confirmPurchase: {
			title: 'Potwierdź zakup',
			message: 'Czy na pewno chcesz kupić ten przedmiot?',
			confirm: 'Tak, kup',
			cancel: 'Anuluj',
		},
	},

	demo: {
		title: 'Darmowa lekcja demo',
		tutorial: {
			title: 'Instrukcja',
			text:
				'Instrukcja\n' +
				'Witamy na próbnej lekcji online arytmetyki mentalnej klubu Indigo Mental Club.\n' +
				'Jesteśmy doświadczonym klubem, działającym w 7 państwach na całym świecie. Mamy na koncie wiele sukcesów związanych z udziałem naszych podopiecznych w międzynarodowych olimpiadach, co dowodzi że nasza innowacyjna technika nauki przynosi rozmaite korzyści. Rodzice, których dzieci korzystają z naszych zajęć, są przekonani o skuteczności naszej metody w rozwoju koncentracji i pamięci. Dzieci osiągają sukcesy nie tylko w sferze arytmetyki mentalnej, lecz także mogą pochwalić się niebywałymi osiągnięciami w dziecinie muzyki, sportu i wielu innych dziedzin, jak nauka języków. Pokazuje to, że nasze zajęcia pozwalają na rozwój zdolności intelektualnych u naszych podopiecznych.\n' +
				'Proces uczenia się bazuje na japońskim liczydle abakus(czasem nazywanym soroban).To dzięki niemu uaktywnia się jednocześnie lewą i prawą półkulę mózgu, poprawiając pamięć wzrokową, koncentrację, kreatywność, wyobraźnię przestrzenną dzieci oraz widzenie peryferyjne, co przekłada się na zdolność opanowania technik szybkiego czytania.\n' +
				'Jeśli wiesz już o co chodzi, możemy zacząć naukę. W tym celu naciśnij PLAY na poniższym filmie - słuchaj, powtarzaj i baw się dobrze!',
		},
	},

	disableStudent: {
		btn: 'Disable student',
		list: 'Students without deactivation date',
		modal: {
			title: 'Disableing a student',
			description: 'You are about to disable the student',
			fieldLabel: 'Select month',
			btnSubmit: 'Disable',
			btnCancel: 'Cancel',
		},
	},
}
